import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SmartImage } from "./SmartImage";
import { useLang } from "../i18n";

export const ProductCard = ({ product, index, className = "" }) => {
  const { t } = useLang();
  return (
    <article
      className={`group bg-white border border-gray-200 flex flex-col transition-shadow duration-300 hover:shadow-[6px_6px_0_#0A1F44] ${className}`}
      data-testid={`product-card-${product.slug}`}
    >
      <Link to={`/products/${product.slug}`} className="block overflow-hidden h-52 md:h-60 relative">
        <SmartImage
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <span className="absolute top-0 left-0 bg-navy text-white font-heading text-xs font-bold px-3 py-2">
          {String(index + 1).padStart(2, "0")}
        </span>
      </Link>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-heading text-xl font-black uppercase tracking-tight text-navy">
          <Link to={`/products/${product.slug}`} className="hover:text-steel transition-colors duration-200">
            {product.name}
          </Link>
        </h3>
        <p className="mt-2 text-sm text-steel leading-relaxed flex-1">{t(`tag.${product.slug}`, product.tagline)}</p>
        <div className="mt-6 flex items-center justify-between border-t border-gray-200 pt-4">
          <Link
            to={`/products/${product.slug}`}
            data-testid={`product-specs-${product.slug}`}
            className="font-heading text-xs font-bold uppercase tracking-[0.15em] text-navy inline-flex items-center gap-1 hover:text-steel transition-colors duration-200"
          >
            {t("card.specs")} <ArrowUpRight size={14} />
          </Link>
          <Link
            to={`/quote?product=${product.slug}`}
            data-testid={`product-enquire-${product.slug}`}
            className="font-heading text-xs font-bold uppercase tracking-[0.15em] bg-navy text-white px-4 py-2 transition-colors duration-200 hover:bg-steel"
          >
            {t("card.enquire")}
          </Link>
        </div>
      </div>
    </article>
  );
};
